<template>
  <vl-grid>
    <vl-column :width="`${labelBefore ? '2' : '12'}`">
      <vl-form-message-label :for="labelFor" :class="{ 'vl-u-visually-hidden': modHiddenLabel }">
        {{ label }}<span v-if="modRequired" class="dl-form-field-error">&nbsp;*</span>
      </vl-form-message-label>
    </vl-column>
    <vl-column :width="`${labelBefore ? '10' : '12'}`">
      <slot :has-errors="hasErrors" :classes="classes"></slot>
      <vl-form-message-error v-if="hasErrors">{{ errorMessage }} </vl-form-message-error>
    </vl-column>
  </vl-grid>
</template>

<script lang="ts" src="./dl-form-field.ts"></script>

<style lang="scss" scoped src="./dl-form-field.scss"></style>
